import React from 'react';
import { Link } from 'react-router-dom';
import { KoFiDialog, KoFiButton } from 'react-kofi';
import 'react-kofi/dist/styles.css';

interface OtherCalcsProps {
  sections?: 'all' | 'calcs' | 'guides';
  showKofi?: boolean;
}

const OtherCalcs: React.FC<OtherCalcsProps> = ({ 
  sections = 'all', 
  showKofi = true 
}) => {
  const showCalcs = sections === 'all' || sections === 'calcs';
  const showGuides = sections === 'all' || sections === 'guides';

  return (
    <div id="other-links">
      {showKofi && (
        <div className="kofi-section center-flex">
          <KoFiButton color="#00b4f7" id="tedzeppelin121" label="Please Support Fat Scientist on Ko-Fi" radius="12px" />
        </div>
      )}

      {showCalcs && (
        <>
          <h2>Fat Scientist Calculators</h2>
          <div className="calculator-grid">
            <Link to="/dosage-calculator" className="calculator-card">
              <div className="card-icon icon-syringe"></div>
              <div className="card-content">
                <div className="card-title">Tirzepatide Dosage Calculator</div>
                <div className="card-description">Calculate dosage for Tirzepatide (Mounjaro/Zepbound)</div>
              </div>
            </Link>

            <Link to="/semaglutide-calculator" className="calculator-card">
              <div className="card-icon icon-calculator"></div>
              <div className="card-content">
                <div className="card-title">Semaglutide Dosage Calculator</div>
                <div className="card-description">Calculate dosage for Semaglutide (Ozempic/Wegovy)</div>
              </div>
            </Link>

            <Link to="/reverse-dosage-calculator" className="calculator-card">
              <div className="card-icon icon-reverse"></div>
              <div className="card-content">
                <div className="card-title">Reverse Dosage Calculator</div>
                <div className="card-description">
                  How much did you take? Calculate the dosage from the units you injected.
                </div>
              </div>
            </Link>

            <Link to="/zepbound-reverse-calculator" className="calculator-card">
              <div className="card-icon icon-zepbound"></div>
              <div className="card-content">
                <div className="card-title">Zepbound Reverse Dosage Calculator</div>
                <div className="card-description">
                  For Zepbound vials: Calculate dosage from units injected and vial's listed dose.
                </div>
              </div>
            </Link>

            <Link to="/vial-transition-calculator" className="calculator-card">
              <div className="card-icon icon-transition"></div>
              <div className="card-content">
                <div className="card-title">Vial Transition Dosage Calculator</div>
                <div className="card-description">
                  Combine doses from two vials (e.g., when finishing one and starting another).
                </div>
              </div>
            </Link>

            <Link to="/split-dose-calculator" className="calculator-card">
              <div className="card-icon icon-split"></div>
              <div className="card-content">
                <div className="card-title">Split Dose Calculator</div>
                <div className="card-description">
                  Convert weekly doses to more frequent schedules (e.g., every 5 days instead of weekly).
                </div>
              </div>
            </Link>

            <Link to="/ousia-dosage-calculator" className="calculator-card">
              <div className="card-icon icon-ousia"></div>
              <div className="card-content">
                <div className="card-title">Ousia Dosage Calculator</div>
                <div className="card-description">Special dosage calculator for Ousia vials</div>
              </div>
            </Link>
          </div>
        </>
      )}

      {showGuides && (
        <div className="guides-section">
          <h2>Guides and FAQs</h2>
          <div className="guides-grid">
            <Link to="/faq/finding-concentration" className="guide-card">
              <div className="guide-icon icon-concentration"></div>
              <div className="guide-content">
                <div className="guide-title">Finding Your Medication Concentration</div>
                <div className="guide-description">Learn how to find and understand your medication's concentration</div>
              </div>
            </Link>

            <Link to="/faq/starting-today-how-to-prepare" className="guide-card">
              <div className="guide-icon icon-starting"></div>
              <div className="guide-content">
                <div className="guide-title">Starting Today: What You Need To Know</div>
                <div className="guide-description">
                  Some things you'll want to know when starting your weight loss journey
                </div>
              </div>
            </Link>

            <Link to="/faq" className="guide-card faq-all-card">
              <div className="guide-icon icon-faq">💬</div>
              <div className="guide-content">
                <div className="guide-title">See All Frequently Asked Questions</div>
                <div className="guide-description">Check out our complete collection of common questions and answers</div>
              </div>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtherCalcs;
